function isEqual(source, target) {
    return moment(source).isSame(target);
}

function now(formatString) {
    return moment().format(formatString);
}

function getUserDateFormat(altDateFormat = 'YYYY-MM-DD') {
    let dateFormat;
    const session = window.SESSION;
    if (!_.isEmpty(session) && _.has(session, '_USER_DATE_FORMAT')) {
        /* eslint no-underscore-dangle: ["error", { "allow": ["_USER_DATE_FORMAT"] }] */
        dateFormat = session._USER_DATE_FORMAT;
    } else {
        dateFormat = altDateFormat;
    }
    return dateFormat;
}

export {
    isEqual,
    now,
    getUserDateFormat,
};



// WEBPACK FOOTER //
// ./src/utils/ec-date.js